import Vuex from 'vuex';
import Vue from 'vue';
import app from '@/store/modules/app';
import empresa from '@/store/modules/empresa';
import tipoListaConsulta from '@/store/modules/tipoListaConsulta';
import user from '@/store/modules/user';
import userIsAdmin from '@/store/modules/userIsAdmin';
import simulacaoLaudoIncremental from '@/store/modules/simulacaoLaudoIncremental';
import movimentacaoBlindada from '@/store/modules/movimentacaoBlindada';
import simuladorBaixas from '@/store/modules/simuladorBaixas';
import projecaoBrr from '@/store/modules/projecaoBrr';
import VuexPersistence from 'vuex-persist';

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  modules: [
    'user',
    'empresa',
    'app'
    // 'NÃO ADICIONAR' modulo userIsAdmin por via de segurança
  ]
});

// Load Vuex
Vue.use(Vuex);

// Create store
export default new Vuex.Store({
  modules: {
    app,
    empresa,
    tipoListaConsulta,
    user,
    userIsAdmin,
    simulacaoLaudoIncremental,
    movimentacaoBlindada,
    simuladorBaixas,
    projecaoBrr
  },
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg',
    drawer: true
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload;
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload;
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload;
    }
  },
  actions: {

  },
  plugins: [vuexLocal.plugin]
});
